/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CreateUserVariableDefinitionInput = {
  dataType: UserVariableDefinitionDataType;
  name: string;
  selectOptions?: Array<string> | null | undefined;
};

export type UserVariableDefinitionDataType =
  | 'MULTIPLE_SELECT'
  | 'SELECT'
  | 'STRING'
  | 'TEXT';

export type CreateUserVariableDefinitionMutationVariables = Exact<{
  input: Types.CreateUserVariableDefinitionInput;
}>;


export type CreateUserVariableDefinitionMutation = { createUserVariableDefinition: { guid: string } };


export const CreateUserVariableDefinitionDocument = gql`
    mutation CreateUserVariableDefinition($input: CreateUserVariableDefinitionInput!) {
  createUserVariableDefinition(input: $input) {
    guid
  }
}
    `;

/**
 * __useCreateUserVariableDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateUserVariableDefinitionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserVariableDefinitionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserVariableDefinitionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserVariableDefinitionMutation(options: VueApolloComposable.UseMutationOptions<CreateUserVariableDefinitionMutation, CreateUserVariableDefinitionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserVariableDefinitionMutation, CreateUserVariableDefinitionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateUserVariableDefinitionMutation, CreateUserVariableDefinitionMutationVariables>(CreateUserVariableDefinitionDocument, options);
}
export type CreateUserVariableDefinitionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateUserVariableDefinitionMutation, CreateUserVariableDefinitionMutationVariables>;